module.exports = __webpack_public_path__ + "img/google_sheets.705d32a3.png";